export default __webpack_public_path__ + "static/media/JOR.ebd1430d.svg";